import Vue from 'vue';
import Component from 'vue-class-component';
@Component
export class FormLayoutMix extends Vue {
    formLayout= {
        labelCol: { span: 6 },
        wrapperCol: { span: 18 },
    };

    layout= {
        labelCol: { span: 5 },
        wrapperCol: { span: 14 },
    };


    inlineLayout = {
        labelCol: {
            xs: { span: 24 },
            sm: { span: 5 },
        },
        wrapperCol: {
            xs: { span: 24 },
            sm: { span: 12 },
        },
    };

    formItemColumnLabelLayout = {
        labelCol: {
            xs: { span: 40 },
            sm: { span: 20 },
        },
        wrapperCol: {
            xs: { span: 50 },
            sm: { span: 40 },
        },
    };

    formItemLayout = {
        labelCol: {
            xs: { span: 24 },
            sm: { span: 4 },
        },
        wrapperCol: {
            xs: { span: 24 },
            sm: { span: 20 },
        },
    };
    formItemLayoutWithOutLabel = {
        wrapperCol: {
            xs: { span: 4, offset: 0 },
            sm: { span: 14, offset: 2 },
        },
    };
    formItemLayoutWithOutLabelButton = {
        wrapperCol: {
            xs: { span: 2, offset: 0 },
            sm: { span: 2, offset: 0 },
        },
    };
}

/*
* */